import moment from 'moment';

export const getDailyResults = (stats, key) =>
  stats?.reduce?.((acc, stats) => {
    const data = stats?.data?.[key] || {};
    const dailyResults = data.daily_results || [];

    return data
      ? [
          ...acc,
          data && {
            ...data,
            daily_results: dailyResults
              .sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);

                return dateA - dateB;
              })
              .map((result) => ({
                ...result,
                date: moment(result.date).format('MMM D'),
              })),
          },
        ].filter(Boolean)
      : acc;
  }, []);
